import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreEntry } from '@types';

const useGetEntry = () => {
    const data = useStaticQuery(graphql`
        query AllEntry {
            allPatstoreEntry {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    date
    state
    
                    }
                }
            }
        }
    
        `);


    const allEntry: PatstoreEntry[] =
        data.allPatstoreEntry.edges.map(
            (edge: { node: PatstoreEntry }) => edge.node
        ) || [];

    const findEntry: (id: string) => PatstoreEntry | undefined = (id: string) => {
        const result = allEntry.find((item: PatstoreEntry) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findEntry,
        entrys: allEntry,
    };
}; 

export default useGetEntry;
